module.exports = __webpack_public_path__ + "img/mod-1.58e94e0f.svg";